"use client";

import { useWorkspaceCheck } from "@/hooks/use-workspace-check";
import WorkspaceSetupModal from "@/components/shared/workspace-setup-modal";

export function WorkspaceCheck() {
  const { showModal, workspaceId, workspaceName, closeModal } =
    useWorkspaceCheck();

  if (!showModal || !workspaceId) return null;

  return (
    <WorkspaceSetupModal
      isOpen={showModal}
      onClose={closeModal}
      currentName={workspaceName}
      workspaceId={workspaceId}
    />
  );
}

